import { makeStyles } from '@material-ui/styles';
import { Values } from '../../../../values/Values';


const useStyles = makeStyles(theme => ({
  root: {
    margin: theme.spacing(3),
    borderRadius: 15
  },
  title: {
    textAlign: 'center',
  },
  instrucoes: {
    textAlign: 'left',
  },
  gridBotaoContinuar: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  botaoContinuar: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.white,
  },
  textoPrimarioItens: {
    textAlign: 'left'
  },
  valoresQuantidade: {
    textAlign: 'right'
  },
  gridBotoesAcoes: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 50
  },
  dividerGrids: {
    display: 'flex',
    justifyContent: 'flex-center'
  },

}));

export {useStyles}

